import { CommonGTMEvents, EventNameFormat, TrackingEvent } from 'types/tracking'
import type { EventTrackingParameters } from 'types/event-tracking-parameters'
import posthog, { CaptureOptions, Properties } from 'posthog-js'

/**
 * Tracks events by pushing data to GTM
 *
 * @param {CommonGTMEvents | string} event
 * @param {EventTrackingParameters} parameters
 */
export const trackGTMEvent = (event: CommonGTMEvents | string, parameters?: EventTrackingParameters): void => {
  if ((window as any).dataLayer) {
    ;(window as any).dataLayer.push({ event, ...parameters })
  }
}

/**
 * Resets the data layer
 */
export const resetDataLayer = (): void => {
  if ((window as any).dataLayer) {
    ;(window as any).dataLayer.push(() => {
      ;(window as any).dataLayer.reset()
    })
  }
}

/**
 * Tracks an event using PostHog
 * @param {TrackingEvent} event - Object of params to format the event name. (snake_case)
 * @param {Properties} data - Additional properties to send with the event.
 * @param {CaptureOptions} options - Optional capture options for PostHog.
 */
export const trackEvent = (event: TrackingEvent, data?: Properties, options?: CaptureOptions) => {
  const eventName: EventNameFormat = event.object
    ? `${event.category}:${event.object}_${event.action}`
    : `${event.category}:${event.action}`

  posthog.capture(eventName, data, options)
}
